<template>
  <transition name="transition" :duration="{ enter: 750, leave: 250 }">
    <nav
      id="mobile-nav"
      v-if="isShowing"
      :style="{ '--height': primaryMenuHeight + 'px' }"
    >
      <div class="touch-close" @click="toggleMobileMenu()"></div>
      <div class="mobile-menu">
        <div
          class="mobile-menu__inner"
          v-bind:style="{ height: primaryMenuHeight + 'px' }"
        >
          <div class="search_form_mobile">
            <form role="search" action="/" method="GET" class="search-form">
              <input
                type="search"
                placeholder="SEARCH"
                value=""
                name="s"
                class="search-field"
              />
              <button type="submit" class="search-submit">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.85544 2.44576C4.72582 2.44576 2.18877 4.98281 2.18877 8.11242C2.18877 11.2421 4.72581 13.7791 7.85544 13.7791C9.31113 13.7791 10.6386 13.2302 11.6422 12.3281L12.0711 11.8992C12.9732 10.8956 13.5221 9.56811 13.5221 8.11242C13.5221 4.9828 10.9851 2.44576 7.85544 2.44576ZM13.9376 12.7804C14.9313 11.4876 15.5221 9.86903 15.5221 8.11242C15.5221 3.87825 12.0897 0.445755 7.85544 0.445755C3.62125 0.445755 0.188766 3.87824 0.188766 8.11242C0.188766 12.3467 3.62126 15.7791 7.85544 15.7791C9.61204 15.7791 11.2307 15.1883 12.5234 14.1946L16.1888 17.86L17.603 16.4458L13.9376 12.7804Z"
                    fill="#4F58F5"
                  ></path>
                </svg>
              </button>
            </form>
          </div>
          <!-- <svg
            
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.707031 23.334L23.3344 0.706568"
              stroke="#27363C"
              stroke-width="2"
            />
            <path
              d="M0.707031 0.707031L23.3344 23.3344"
              stroke="#27363C"
              stroke-width="2"
            />
          </svg> -->


          <svg class="close-icon"
          @click="toggleMobileMenu()" width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5498 -0.00488281C22.5818 -0.00462205 29.1053 6.42947 29.1055 14.3799C29.1052 22.3302 22.5817 28.7654 14.5498 28.7656C6.51785 28.7654 -0.00461574 22.3303 -0.00488281 14.3799C-0.00466896 6.42947 6.51782 -0.00463225 14.5498 -0.00488281ZM14.5498 1.06543C7.09642 1.06568 1.06564 7.03268 1.06543 14.3799C1.0657 21.727 7.09645 27.6951 14.5498 27.6953C22.0031 27.6951 28.0349 21.727 28.0352 14.3799C28.0349 7.03269 22.0032 1.06569 14.5498 1.06543ZM19.3096 9.69043L19.6855 10.0713L15.3164 14.3799L19.6855 18.6895L19.3096 19.0703L18.9346 19.4512L14.5547 15.1309L10.1758 19.4512L9.42383 18.6895L13.793 14.3799L9.42383 10.0713L10.1758 9.30957L14.5547 13.6289L18.9346 9.30957L19.3096 9.69043Z" fill="#53628B"/>
</svg>


          <div
            ref="menuDepth0"
            class="mobile-menu__panel mobile-menu__panel--depth-0"
            v-if="menuData"
            :class="{ current: depth == 0, previous: depth > 0 }"
          >
            <ul class="mobile-menu-links top-menu">
              <li
                v-for="post in secMenuData"
                :key="post.ID"
                :class="post.classes"
                class="sec-menu__item"
              >
                <div class="icon-wrapper" v-if="post['menu_icon_alt']">
                  <img :src="post['menu_icon_alt']" :alt="post['title']" />
                </div>
                <a
                  :href="post.url"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                >
                  <span v-html="post.title"></span>
                </a>
                <img
                  v-if="post.children && post.children.length > 0"
                  v-on:click.prevent="didSelectPost(post)"
                  :src="arrow"
                  alt="Has Children"
                />
              </li>
            </ul>
            <ul class="mobile-menu-links bottom-menu">
              <li v-if="showHomeLink">
                <a href="/" :class="{ selected: currentId <= 0 }">Home</a>
              </li>
              <li v-for="post in menuData" :key="post.ID" :class="post.classes">
                <div
                  v-if="post.children && post.children.length > 0"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                  v-on:click.prevent="didSelectPost(post)"
                >
                  <span v-html="post.title"></span>
                </div>
                <a
                  v-else
                  :href="post.url"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                >
                  <span v-html="post.title"></span>
                </a>
                <img
                  v-if="post.children && post.children.length > 0"
                  v-on:click.prevent="didSelectPost(post)"
                  :src="arrow"
                  alt="Has Children"
                />
              </li>
              <!-- <primary-button
                v-if="globalSettings.general.cta"
                :link="globalSettings.general.cta"
                :label="globalSettings.general.cta.title"
                :target="globalSettings.general.cta.target"
              ></primary-button>
              <secondary-button
                v-if="globalSettings.general.cta_two"
                :link="globalSettings.general.cta_two"
                :label="globalSettings.general.cta_two.title"
                :target="globalSettings.general.cta_two.target"
                theme="mob-menu"
              ></secondary-button> -->
            </ul>
          </div>
          <div
            ref="menuDepth1"
            class="mobile-menu__panel mobile-menu__panel--depth-1"
            v-if="menuForDepth1"
            :class="{
              current: depth == 1,
              previous: depth > 1,
              next: depth < 1,
            }"
          >
            <div
              v-if="selectedMenu0"
              class="mobile-menu-footer mega-menu-li-back"
            >
              <a
                :href="selectedMenu0.url"
                v-on:click.prevent="didSelectBack()"
                class="back"
              >
                <img :src="arrow" alt="Main Menu" />
                <div v-html="selectedMenu0.title"></div>
              </a>
            </div>
            <ul class="mobile-menu-links" v-if="selectedMenu0">
              <!-- <li :key="selectedMenu0.ID" class="mega-menu-li-header">
                <a
                  :href="selectedMenu0.url"
                  v-on:click.prevent="didSelectPost(selectedMenu0, true)"
                >
                  <h3 v-html="selectedMenu0.title"></h3>
                </a>
              </li> -->
              <template v-if="selectedMenu0.classes.includes('mega-menu')">
                <li
                  v-for="post in menuForDepth1"
                  :key="post.ID"
                  :class="post.classes"
                  class="mega-menu-li"
                >
                  <a
                    :href="post.url"
                    :class="{
                      selected: post.object_id == currentId,
                    }"
                    v-if="!post.classes.includes('hidden-title')"
                  >
                    <h5
                      :class="post.classes.join(', ')"
                      v-html="post.title"
                    ></h5>
                  </a>
                  <ul>
                    <li
                      v-for="(post, index) in post.children"
                      :key="post.ID"
                      :id="index"
                      :class="[
                        post.classes.join(', '),
                        { 'has-icon': post['menu_icon'] },
                      ]"
                    >
                      <div class="icon-wrapper" v-if="post['menu_icon']">
                        <img :src="post['menu_icon']" :alt="post['title']" />
                      </div>
                      <a :href="post.url" :class="post['classes'].join(', ')">
                        <span v-html="post.title"></span>
                      </a>
                      <svg
                        v-if="post['classes'].includes('sub-cta')"
                        width="7"
                        height="11"
                        viewBox="0 0 7 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.09024 5.14457L0.555176 1.60893L1.96951 0.194832L6.91845 5.14459L1.9695 10.0942L0.555184 8.68012L4.09024 5.14457Z"
                          fill="#4F58F5"
                        />
                      </svg>
                    </li>
                  </ul>
                </li>
                <div
                  v-if="selectedMenu0.call_to_action_link"
                  class="sub_menu_cta"
                  :class="{
                    'has-cta': selectedMenu0.call_to_action_link != null,
                  }"
                >
                  <h3 v-html="selectedMenu0.call_to_action_description"></h3>
                  <div
                    class="sub_menu_cta__wrapper"
                    v-if="selectedMenu0.call_to_action_link"
                  >
                    <secondary-button
                      :link="selectedMenu0.call_to_action_link"
                      :label="selectedMenu0.call_to_action_link.title"
                      :target="selectedMenu0.call_to_action_link.target"
                    ></secondary-button>
                  </div>
                </div>
              </template>
              <template v-else>
                <li
                  v-for="post in menuForDepth1"
                  :key="post.ID"
                  :class="post.classes"
                >
                  <div
                    v-if="post.children && post.children.length > 0"
                    :class="{
                      selected: post.object_id == currentId,
                    }"
                    v-on:click.prevent="didSelectPost(post)"
                  >
                    <span v-html="post.title"></span>
                  </div>
                  <a
                    v-else
                    :href="post.url"
                    :class="{
                      selected: post.object_id == currentId,
                    }"
                  >
                    <img
                      class="icon"
                      v-if="post.icon"
                      :src="post.icon"
                      :alt="post.title"
                    />
                    <span v-html="post.title"></span>
                  </a>
                  <img
                    v-if="post.children && post.children.length > 0"
                    v-on:click.prevent="didSelectPost(post)"
                    :src="arrow"
                    alt="Has Children"
                  />
                </li>
              </template>
            </ul>
          </div>
          <div
            ref="menuDepth2"
            class="mobile-menu__panel mobile-menu__panel--depth-2"
            v-if="menuForDepth2"
            :class="{
              current: depth == 2,
              previous: depth > 2,
              next: depth < 2,
            }"
          >
            <ul class="mobile-menu-links" v-if="selectedMenu1">
              <li :key="selectedMenu1.ID">
                <a
                  :href="selectedMenu1.url"
                  v-on:click.prevent="didSelectPost(selectedMenu1, true)"
                >
                  <h3 v-html="selectedMenu1.title"></h3>
                </a>
              </li>
              <li
                v-for="post in menuForDepth2"
                :key="post.ID"
                :class="post.classes"
              >
                <a
                  :href="post.url"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                  ><span v-html="post.title"></span
                ></a>
                <img
                  v-if="post.children && post.children.length > 0"
                  v-on:click.prevent="didSelectPost(post)"
                  :src="arrow"
                  alt="Has Children"
                />
              </li>
            </ul>
          </div>
          <div
            ref="menuDepth3"
            class="mobile-menu__panel mobile-menu__panel--depth-3"
            v-if="menuForDepth3"
            :class="{ current: depth == 3, next: depth < 3 }"
          >
            <ul class="mobile-menu-links">
              <li
                v-for="post in menuForDepth3"
                :key="post.ID"
                :class="post.classes"
              >
                <a
                  :href="post.url"
                  :class="{
                    selected: post.object_id == currentId,
                  }"
                >
                  <span v-html="post.title"></span>
                </a>
                <img
                  v-if="post.children && post.children.length > 0"
                  v-on:click.prevent="didSelectPost(post)"
                  :src="arrow"
                  alt="Has Children"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </transition>
</template>

<script>
import Arrow from '../../images/mobile-children.svg';
// import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';
import Search from '../../images/search.svg';

export default {
  data() {
    return {
      selectedPrimaryPost: null,
      selectedSecondaryPost: null,
      selectedTertiaryPost: null,
      selectedMenuData: null,
      arrow: Arrow,
      searchQuery: '',
      searchIcon: Search,
      depth: 0,
      primaryMenuHeight: 280,
      selectedMenu0: null,
      selectedMenu1: null,
      selectedMenu2: null,
      selectedMenu3: null,
    };
  },

  props: {
    menuData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    secMenuData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    globalSettings: {},
    currentId: {
      type: Number,
      default: -1,
    },
    isShowing: {
      type: Boolean,
      default: false,
    },
    showHomeLink: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    menuForDepth1: function () {
      return this.selectedMenu0 ? this.selectedMenu0.children : [];
    },
    menuForDepth2: function () {
      return this.selectedMenu1 ? this.selectedMenu1.children : [];
    },
    menuForDepth3: function () {
      return this.selectedMenu2 ? this.selectedMenu2.children : [];
    },
    parsedMenuData() {
      if (this.menuData) {
        return this.menuData;
      } else {
        return null;
      }
    },
  },

  methods: {
    toggleMobileMenu() {
      this.$store.commit('toggleMobileMenu', !this.$store.state.mobile_menu);
    },

    triggerToggleSearch() {
      this.$emit('trigger-toggle-search');
    },

    layoutSubviews: function () {
      var height = 0,
        panelEl = this.$refs['menuDepth' + this.depth];

      if (typeof panelEl === 'undefined') return;

      height = panelEl.clientHeight;
      this.primaryMenuHeight = height;
    },
    didSelectBack: function () {
      if (this.depth > 0) {
        this.depth -= 1;
      }
    },
    didSelectPost: function (item, ignoreChildren = false) {
      const self = this;

      if (item.children && !ignoreChildren) {
        var newDepth = item.depth + 1;

        switch (newDepth) {
          case 1:
            {
              self.selectedMenu0 = item;
            }
            break;

          case 2:
            {
              self.selectedMenu1 = item;
            }
            break;

          case 3:
            {
              self.selectedMenu2 = item;
            }
            break;

          default:
        }

        self.depth = newDepth;

        return;
      }

      window.location.href = item.url;
    },
  },

  components: {
    // PrimaryButton,
    SecondaryButton,
  },

  mounted() {
    var self = this;
    setTimeout(function () {
      self.layoutSubviews();
    }, 150);
  },

  updated() {
    this.layoutSubviews();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

$mobile-menu-item-min-height: 72px;
$mobile-menu-footer-min-height: 82px;

#mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  -webkit-overflow-scrolling: touch;

  .touch-close {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
  }

  .scrolled & {
    position: fixed;
  }

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.25s;

    .container {
      transition: transform 0.25s;
    }
  }

  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
  }

  &.fade-leave-to {
    .container {
      transform: translateY(-10px);
    }
  }

  &.transition-enter-active,
  &.transition-leave-active {
    transition: background 0.15s ease-in-out, opacity 0.1s ease-in-out;

    .mobile-menu {
      transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
    }
  }

  &.transition-enter-active {
    .mobile-menu {
      transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);

      .page-showing-menu & {
        transition-delay: 0.25s;
      }
    }
  }

  &.transition-leave-active {
    .mobile-menu {
      transition-duration: 0.25s;
      transition-timing-function: cubic-bezier(0.36, 0, 0.22, 0);
    }
  }

  &.transition-enter,
  &.transition-leave-to {
    .mobile-menu {
      transform: translateX(120%);
    }
  }

  .mobile-menu {
    background: transparent;
    transition: 0.2s ease all;
    justify-content: flex-end;
    display: flex;
    position: relative;
    pointer-events: none;

    &__inner {
      position: relative;
      overflow: hidden;
      background: var(--light-grey);
      color: var(--white);
      transition: 0.2s ease all;
      height: 100vh !important;
      width: 100vw !important;
      right: 0;
      pointer-events: all;
      overflow-y: hidden;

      .search_form_mobile {
        padding: 20px;
        width: calc(100% - 40px);
        background: var(--white);

        .search-form {
          position: relative;
          border: 1px solid var(--fpe-blue);
          border-radius: 30px;
          overflow: hidden;
          display: flex;
          align-items: center;
          width: 250px;

          .search-field {
            border: none;
            padding: 10px 20px 7px;
            width: 100%;
            background: transparent;
            color: #27363c;
            font-size: 16px;
            display: flex;
            align-items: center;
            line-height: 0;

            &::placeholder {
              color: var(--fpe-blue);
              font: normal normal 300 14px/20px var(--primary-font-family);
              text-transform: uppercase;
              opacity: 1;
            }

            &:focus {
              outline: none;
            }
          }

          .search-submit {
            background: transparent;
            border: none;
            padding: 0 15px 0 0;
            cursor: pointer;
            display: flex;
            align-items: center;

            svg {
              path {
                fill: var(--fpe-blue);
              }
            }
          }
        }
      }

      .close-icon {
        position: absolute;
        right: 20px;
        top: 20px;
        display: flex;

        &:hover {
          cursor: pointer;
        }
      }

      .back {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        text-decoration: none;
        color: var(--fpe-blue);
        opacity: 1;
        gap: 9.5px;
        font: normal normal bold 14px/18px var(--primary-font-family);
        letter-spacing: 0.14px;
        padding: 0 0 24px;

        &:hover,
        &:active {
          text-decoration: none;
          opacity: 1;
        }

        img {
          transform: rotate(-180deg);
        }

        svg {
          path {
            fill: var(--fpe-blue);
          }
        }

        p,
        span {
          color: var(--fpe-blue);
          font-weight: 600;
          font-size: 15px;
          line-height: 18px;
        }
      }
    }

    &__panel {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: $z-index-low;
      transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
      margin-top: 75px;
      overflow-y: scroll;
      background-color: var(--fpe-light-grey);

      &--depth-1,
      &--depth-2,
      &--depth-3 {
        margin-top: 75px;

        .mega-menu-li {
          border-bottom: 1px solid var(--fpe-blue) !important;
          padding: 24px 0 0 !important;
          margin-bottom: 0 !important;

          a {
            padding-bottom: 4px !important;

            h5 {
              font: normal normal 300 16px/24px var(--primary-font-family) !important;
              text-transform: unset !important;
            }
          }

          > ul {
            display: none;
          }
        }
      }

      .mega-menu-li-back {
        .back  {
          div {
            font: normal normal 300 16px/24px var(--primary-font-family) !important;
            text-transform: uppercase !important;
          }
        }
      }

      body.logged-in &,
      body.admin-bar & {
        margin-top: 48px + 32px;

        @media (max-width: $mobile-xl) {
          margin-top: 48px + 41px;
        }
      }

      &.next {
        pointer-events: none;
        transform: translateX(50%);
        opacity: 0;
      }

      &.current {
        pointer-events: all;
        transform: translateX(0);
        opacity: 1;
        z-index: $z-index-medium;
      }

      &.previous {
        pointer-events: none;
        transform: translateX(-50%);
        opacity: 0;
      }

      .mobile-menu-footer {
        padding: 0 $page-gutter-width-xs;
        margin-top: 24px;

        &.mega-menu-li {
          &-back {
            .back {
              padding-bottom: 0;
            }
          }
        }
      }

      .mobile-menu-links {
        list-style: none;
        margin: 0;
        padding: 0 $page-gutter-width-xs 24px $page-gutter-width-xs;

        &.top-menu {
          background-color: var(--white);
        }

        .search {
          display: flex;
          gap: 10px;
          margin-bottom: 16px;

          &:hover {
            cursor: pointer;
          }

          p {
            margin: 0;
            color: var(--fpe-blue);
          }

          img {
            width: 20px;
          }
        }

        > li {
          margin: 0;
          padding: 0;
          display: block;
          display: flex;
          justify-content: space-between;

          .mobile-menu__panel--depth-0 & {
            border-bottom: 1px solid var(--fpe-blue);
          }

          &:first-child {
            border-top: none;
          }

          > img {
            padding: 16px 0 16px 32px;

            &:hover {
              cursor: pointer;
            }
          }

          > a,
          > div {
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: var(--fpe-blue);
            opacity: 1;
            text-decoration: none;
            padding: 24px 0 4px;
            width: 100%;
            column-gap: 16px;

            &:hover,
            &:active {
              text-decoration: none;
              opacity: 1;
              cursor: pointer;

              &::before {
                opacity: 1;
              }

              &::after {
                transform: translateX(5px);
              }
            }

            &.selected {
              &.has-children {
                &:hover,
                &:active {
                  text-decoration: none;
                }
              }
            }

            h3 {
              color: var(--fpe-blue);
              margin: 0;
            }

            span {
              color: var(--fpe-blue);
              font: normal normal 300 16px/24px var(--primary-font-family);
              text-transform: uppercase;
            }
          }

          &.mega-menu-li {
            display: flex;
            flex-direction: column;
            border-bottom: 0;
            margin-bottom: 32px;

            &-back {
              .back {
                padding-bottom: 0;
              }
            }

            &-header {
              border-bottom: 0;
              padding-top: 0;
              margin-top: 16px;
              margin-bottom: 32px;

              &:first-child {
                padding-top: 0;
              }

              a {
                padding-bottom: 0;

                h3 {
                  margin: 0;
                }
              }
            }

            > a {
              span {
                font: normal normal normal 14px/20px var(--primary-font-family);
                text-transform: uppercase;
                color: var(--fpe-blue);

                &.hidden-title {
                  display: none;
                }
              }

              h5 {
                color: var(--fpe-blue);
                text-transform: uppercase;
                margin: 0;
              }
            }
          }
        }

        .sub_menu_cta {
          grid-column: span 1;
          background: var(--emerald);
          padding: 24px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: flex-start;
          position: relative;
          margin-right: -20px;
          margin-left: -20px;
          margin-top: 48px;

          &.has-cta {
            justify-content: space-between;
          }

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -100%;
            height: 100%;
            width: 100%;
            background: var(--emerald);
          }

          h3 {
            margin-top: 0;
          }
        }

        .sec-menu {
          margin-top: 56px;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          gap: 24px;

          &__item {
            display: flex;
            gap: 8px;

            .icon-wrapper {
              display: flex;
            }

            a {
              text-decoration: none;
              width: 100%;

              span {
                color: var(--fpe-blue);
              }
            }
          }
        }

        .site_button {
          margin-top: 32px;
        }
      }
      &--depth-0 {
        .mobile-menu-links {
          > li {
            border-bottom: 1px solid var(--fpe-blue);
          }
        }
      }

      &--depth-1,
      &--depth-2,
      &--depth-3,
      &--depth-4 {
        .mobile-menu-links {
          padding: 0 $page-gutter-width-xs 0 $page-gutter-width-xs;

          > li {
            a {
              padding: 24px 0 16px;
            }

            &:first-child {
              padding-top: 16px;
              padding-bottom: 0;
              border-top: 0;

              a {
                border: none;
                opacity: 1;
                font: normal normal 600 24px/28px var(--primary-font-family);
                letter-spacing: 0px;
                color: var(--white);
              }
            }

            &:last-child {
              > a {
                padding: 0 0 16px 0;
              }
            }

            > a {
              opacity: 1;
              color: var(--white);
              text-transform: none;
              min-height: auto;
              padding: 0 0 16px;
            }
          }
        }
      }
    }

    &__footer {
      text-align: center;
      padding: 0 $page-gutter-width-xs;

      .search-box {
        margin-bottom: ($grid-gutter-width/2);
      }

      .social {
        justify-content: flex-start;
        margin-bottom: ($grid-gutter-width/2);
      }
    }
  }
}

.fade-enter-active {
  animation: fade-in 0.25s;
}

.fade-leave-active {
  animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MobileMenu.vue